import React, { useEffect, useState, useCallback } from 'react';
import PageTitle from "../components/PageTitle";
import __ from "../utils/translator";
import PageHeader from "../components/PageHeader";
import styled, { css } from "styled-components";
import LanguageStoreActions from "../flux/LanguageStoreActions";
import LanguageStore from "../flux/LanguageStore";
import Button from "../components/Button";
import UserStoreActions from "../flux/UserStoreActions";
import UserStore from "../flux/UserStore";
import Header from '../components/organisms/Header';

export default function Languages() {
  const user = UserStore.getState();
  const [languages, setLanguages] = useState(LanguageStore.getState());
  const [currentLanguageCode, setCurrentLanguageCode] = useState(user.language === null ? null : user.language.code);

  useEffect(function() {
    const subscriptions = [];

    subscriptions.push(LanguageStore.addListener(() => {
      setLanguages(LanguageStore.getState());
    }));

    subscriptions.push(UserStore.addListener( () => {
      const user = UserStore.getState();
      setCurrentLanguageCode(user.language === null ? null : user.language.code);
    }));

    if(languages.length === 0) {
      LanguageStoreActions.fetch();
    }

    if(currentLanguageCode === null) {
      UserStoreActions.fetch();
    }

    return function() {
      subscriptions.forEach(subscription => subscription.remove());
    }
  }, []);

  const handleLanguageChange = useCallback(function(language) {
    UserStoreActions.updateLanguage(language.code);
    setCurrentLanguageCode(language.code);
  }, []);

  return (
    <div>
      <Header actions={['back']} />

      <PageTitle withTracking title="Language" />

      <PageHeader
        smallTitle
        crumbs={[__('Home'), __('Language')]}
        compact
        title={__('Language')}
        style={{ height: 'auto' }} />

      <Container>
        {languages.map(language => (
          <LanguageButton
            key={language.code}
            onClick={() => handleLanguageChange(language)}
            selected={currentLanguageCode === language.code}
          >
            {__(language.name)}
          </LanguageButton>
        ))}
      </Container>
    </div>
  );
};

const Container = styled.div`
  padding: 0 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  > button:last-child {
   margin-bottom: 0;
  }
`;

const LanguageButton = styled( ({selected, ...props}) =>
  <Button {...props} />
)`
  width: 12.5rem;
  height: 2.5rem;
  margin-bottom: .25rem;
  border: .0625rem solid #000;
  background-color: #fff;
  color: #000;
  text-transform: none;

  ${({ selected }) => selected && css`
    background-color: #000;
    color: #fff;
    font-weight: bold;
  `};
`;
